module.exports = __webpack_public_path__ + "img/mon_24.bd52e887.png";